import React from 'react';
import { Link } from 'react-router-dom';
import LookerReport from './LookerReport';

const BookingProcessAnalytics = () => {
  return (
    <LookerReport
      source="booking_process"
      title="Booking Process Analytics"
    />
  );
};

export default BookingProcessAnalytics;